import CTASection from "@/components/CTASection";

const SECTIONS = [
  { h: "1. Information We Collect", body: [
    "We may collect the following types of personal information.",
    "Information you provide directly: name, email address, phone number, business name, website URL, marketing goals or project details, billing and payment information where applicable, and any information you submit through contact forms, lead forms, surveys, or email.",
    "Information collected automatically: IP address, browser type and device information, pages visited, time spent on pages, referral source, general location data, and website interactions. This information helps us improve our website and marketing performance."
  ]},
  { h: "2. How We Use Your Information", body: [
    "We use your information to respond to enquiries, provide marketing services, prepare proposals and quotations, communicate about projects, send newsletters or marketing communications where you have opted in, improve our website and services, analyse website performance, and meet our legal obligations."
  ]},
  { h: "3. Marketing Communications", body: [
    "If you subscribe to our mailing list or request information from us, we may send occasional updates, marketing tips, promotions, and company news. You can unsubscribe at any time using the unsubscribe link in our emails or by contacting us directly."
  ]},
  { h: "4. Cookies and Tracking Technologies", body: [
    "Our website may use cookies and similar technologies to improve website functionality, remember your preferences, measure website traffic, analyse visitor behaviour, improve advertising performance, and deliver relevant advertising. Cookies may be placed by us or trusted third-party providers. You can disable cookies through your browser settings; however, doing so may affect certain website functionality."
  ]},
  { h: "5. Third-Party Services", body: [
    "We use trusted third-party providers to operate our business. These may include Google Analytics, Google Ads, Meta (Facebook and Instagram), LinkedIn, ActiveCampaign or other email marketing platforms, CRM and project management software, payment providers, and website hosting providers. These providers may collect or process information in accordance with their own privacy policies."
  ]},
  { h: "6. Advertising and Remarketing", body: [
    "We may use advertising platforms such as Google Ads, Meta Ads, LinkedIn Ads, and other digital advertising services. These platforms may use cookies or similar technologies to measure campaign performance, build audience insights, deliver personalised advertisements, and show remarketing advertisements after you have visited our website. You can manage advertising preferences through your Google, Meta, or LinkedIn account settings."
  ]},
  { h: "7. Sharing Your Information", body: [
    "We do not sell your personal information. We may share information with employees and contractors working on your project, trusted technology providers, professional advisers, and government authorities where required by law. We only share information necessary to provide our services."
  ]},
  { h: "8. Data Security", body: [
    "We take reasonable steps to protect your personal information from unauthorised access, loss, misuse, or disclosure. While no online system is completely secure, we use appropriate technical and organisational safeguards to protect your information."
  ]},
  { h: "9. Data Retention", body: [
    "We retain personal information only for as long as necessary to provide our services, maintain business records, comply with legal obligations, resolve disputes, and enforce our agreements. When information is no longer required, it is securely deleted or anonymised."
  ]},
  { h: "10. Your Rights", body: [
    "Depending on applicable privacy laws, you may have the right to request access to your personal information, request correction of inaccurate information, request deletion of your information where appropriate, withdraw consent for marketing communications, and lodge a complaint with the Privacy Commissioner. To exercise these rights, please contact us using the details below."
  ]},
  { h: "11. Links to Other Websites", body: [
    "Our website may contain links to third-party websites. We are not responsible for the privacy practices or content of those websites. We encourage you to review their privacy policies before providing personal information."
  ]},
  { h: "12. Children's Privacy", body: [
    "Our services are intended for businesses and individuals aged 18 years and over. We do not knowingly collect personal information from children."
  ]},
  { h: "13. Changes to This Policy", body: [
    "We may update this Privacy Policy from time to time. The latest version will always be available on our website, and the Effective Date at the top of this page will indicate when it was last updated."
  ]},
  { h: "14. Contact Us", body: [
    "If you have any questions about this Privacy Policy or how we handle your personal information, please contact us.",
    "Onboard Marketing",
    "Email: aimee@onboard.nz",
    "Website: https://onboard.nz/marketing",
    "Phone: 021 031 4301"
  ]},
  { h: "New Zealand Privacy Act", body: [
    "Onboard Marketing complies with the Privacy Act 2020 (New Zealand) and takes reasonable steps to ensure your personal information is collected, stored, used, and disclosed in accordance with New Zealand privacy law."
  ]},
];

export default function Privacy() {
  return (
    <div data-testid="privacy-page">
      <section className="pt-16 pb-12 lg:pt-24">
        <div className="ob-container">
          <h1 className="ob-h1 max-w-4xl">Privacy Policy</h1>
          <p className="ob-lead mt-6" style={{ color: "var(--ob-muted)" }}>Effective Date: 23 July 2026</p>
          <p className="ob-lead mt-8 max-w-3xl">
            At Onboard Marketing ("we", "our", or "us"), we are committed to protecting your privacy and handling your personal information responsibly. This Privacy Policy explains how we collect, use, disclose, and protect your information when you visit our website, engage our services, or interact with us. By using our website or providing us with your information, you agree to the practices outlined in this Privacy Policy.
          </p>
        </div>
      </section>

      <section className="pb-24">
        <div className="ob-container max-w-4xl space-y-14">
          {SECTIONS.map((s, i) => (
            <div key={i} className="border-t border-[var(--ob-border)] pt-8">
              <h2 className="ob-h3 mb-6">{s.h}</h2>
              {s.body.map((p, j) => (
                <p key={j} className="ob-body mb-4">{p}</p>
              ))}
            </div>
          ))}
        </div>
      </section>

      <CTASection />
    </div>
  );
}
